export default {
  label: 'Meldingen',
  empty: 'Er zijn geen meldingen voor je',
  mark_as_seen: 'Markeer als gelezen',
  mark_all_as_seen: 'Markeer alles als gelezen'
};
